import RequestCreator from './BaseRequest';

export interface SerproValidTokenModel {
  token: string;
}

class SerproValidToken extends RequestCreator<any> {}

const api = new SerproValidToken('/valid-token/serpro');
export default api;
